// extracted by mini-css-extract-plugin
export default {"MyBtn":"MyBtnBlack_MyBtn__JmwQB","popup":"MyBtnBlack_popup__VLXpK","padding":"MyBtnBlack_padding__Guf23"};